import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Stack, Typography, Box } from '@mui/material';
import { useLocales } from '../../locales';
import qrcode from 'qrcode-generator';
import { format } from 'date-fns';

const LiveClock = ({ isHidden = false }) => {
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        // Only run interval if not hidden
        if (isHidden) return;

        const interval = setInterval(() => {
            setTime(new Date());
        }, 1000);

        return () => clearInterval(interval);
    }, [isHidden]);

    return (
        <Typography variant="h6" sx={{ fontFamily: 'monospace', letterSpacing: 2 }}>
            {format(time, 'HH:mm:ss')}
        </Typography>
    );
};

export const EntranceCodeDialog = ({ open, onClose, subscription, sellerId, endUser, hideNameAndTime = false }) => {
    const { translate } = useLocales();
    const [qrCodeElementId] = useState(`qr_entrance_${subscription?._id}_${Math.random()}`);

    const generateQRCode = () => {
        if (!subscription || !sellerId) return;

        const qrUrl = `${window.location.origin}/seller-scanner/${sellerId}/${subscription._id}`;
        // Use higher version (more capacity) and lower error correction for longer URLs
        const qr = qrcode(7, "L");
        qr.addData(qrUrl);
        qr.make();
        const qrElement = document.getElementById(qrCodeElementId);
        if (qrElement) {
            qrElement.innerHTML = qr.createSvgTag(4.5);
        }
    };

    useEffect(() => {
        if (open) {
            // Small delay to ensure the modal is rendered
            setTimeout(() => {
                generateQRCode();
            }, 100);
        }
    }, [open, subscription, sellerId]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                {translate('dashboard.profile_settings.entrance_code_modal_title')}
            </DialogTitle>
            <DialogContent>
                <Stack spacing={2} alignItems="center">
                    {/* QR Code - First */}
                    <Box sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
                        <div id={qrCodeElementId} />
                    </Box>

                    {/* Name and Time on same row - Conditionally rendered */}
                    {!hideNameAndTime && (
                        <Stack direction="row" spacing={3} alignItems="center" justifyContent="center">
                            {/* Member Name */}
                            {endUser && (
                                <Typography variant="h6" fontWeight="medium">
                                    {endUser.fname} {endUser.lname}
                                </Typography>
                            )}

                            {/* Live Clock */}
                            <LiveClock isHidden={hideNameAndTime} />
                        </Stack>
                    )}

                    {/* Description - Last */}
                    <Typography variant="body2" textAlign="center" sx={{ mt: 1 }}>
                        {translate('dashboard.profile_settings.entrance_code_description')}
                    </Typography>
                </Stack>
            </DialogContent>
            <DialogActions>
            </DialogActions>
        </Dialog>
    );
};
